import { useCallback, useEffect, useRef, useState } from 'react';
import {
	getStoredPage,
	getStoredPerPage,
	setStoredPage,
	setStoredPerPage,
} from '../utils/tablePaginationStorage';

export function usePersistedPagination(storageKey, defaultPerPage = 10) {
	const [currentPage, setCurrentPageState] = useState(() =>
		getStoredPage(storageKey, 1)
	);
	const [perPage, setPerPageState] = useState(() =>
		getStoredPerPage(storageKey, defaultPerPage)
	);

	const setCurrentPage = useCallback(
		(page) => {
			const safePage = Math.max(1, page);
			setCurrentPageState(safePage);
			setStoredPage(storageKey, safePage);
		},
		[storageKey]
	);

	const setPerPage = useCallback(
		(size) => {
			const safeSize = Math.max(1, size);
			setPerPageState(safeSize);
			setStoredPerPage(storageKey, safeSize);
		},
		[storageKey]
	);

	const resetToFirstPage = useCallback(() => {
		setCurrentPage(1);
	}, [setCurrentPage]);

	return {
		currentPage,
		perPage,
		setCurrentPage,
		setPerPage,
		resetToFirstPage,
		paginationDefaultPage: currentPage,
	};
}

export function useResetPageOnFilterChange(resetToFirstPage, filterDeps) {
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}

		resetToFirstPage();
	}, filterDeps);
}
